export const API = process.env.REACT_APP_BACKEND
export const APIV2 = process.env.REACT_APP_BACKEND_V2